/*!
 */

;(function ( $, window, document, undefined ) {

    var pluginName = 'beSummerNote',
        defaults = {
            propertyName: "value"
        };

    // The actual plugin constructor
    function Plugin( element, options ) {
        this.element = element;
        this.$element = $(element);

        this.options = $.extend( {}, defaults, options) ;

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    Plugin.prototype.init = function () {
        var Plugin = this;
        Plugin.initSummernotes();
        if(Plugin.$element.summernote('isEmpty') ){
            Plugin.$element.summernote('code','');
        }
    };

    Plugin.prototype.initSummernotes = function () {
        var Plugin = this;
        var customTags = [];
        $.get({
            url: '/custom-wysiwyg-tags',
            async: false,
            success: function(data) { customTags = data.customTags }
        });

        var ParametrosButton = function (context) {

            var ui = $.summernote.ui;

            // create button
            var event = ui.buttonGroup([
                ui.button({
                    contents: 'Estilos beWanted <i class="note-icon-caret" aria-hidden="true"></i>',
                    tooltip: 'Event Data',
                    data: {
                        toggle: 'dropdown'
                    }
                }),
                ui.dropdown({
                    //Etiquetas estilos propios items
                    items: customTags,
                    callback: function (items) {
                        $(items).find('li a').on('click', function(e){
                            e.preventDefault();
                            context.invoke("editor.insertText", '<'+$(this).html()+'>'+Plugin.getSelected()+'</'+$(this).html()+'>')
                        })
                    }
                })
            ]);

            return event.render();   // return button as jquery object
        };

        Plugin.$element.summernote({
            height: 150,
            focus: true,
            toolbar: [
                ['myotherbutton', ['parametros']],
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'picture', 'hr', 'codeview']]
            ],
            buttons: {
                parametros: ParametrosButton,
            },
            hint: {
                match: /#(\w{2,})$/,
                search: function (keyword, callback) {
                    $.ajax({
                        type: 'POST',
                        dataType: 'json',
                        url: 'some_url'
                    }).then(function (data) {
                        callback(data.items);
                    });
                },
                content: function (item) {
                    return '{*' + item.slug + '*} ';
                    //return $('<b>{'+item.slug+'}</b> ').append(" ")[0];
                },
                template: function (item) {
                    return '[<strong>' + item.slug + '</strong>] ' + item.name;
                }
            }
        });
        $('.note-style, .note-fontname, .note-para, .note-color').remove();
    };

    Plugin.prototype.getSelected = function(){
        var t = '';
        //selecciona texto seleccionado dentro del summernote
        if($(window.getSelection().baseNode).closest('.note-editable').length > 0) {
            t = window.getSelection();
        }
        return t;
    };



    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function ( options ) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName,
                    new Plugin( this, options ));
            }
        });
    }

})( jQuery, window, document );/**
 * Created by miguelgonzalez on 17/04/18.
 */
